import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const API_BASE_URL =
    process.env.NODE_ENV === "development"
        ? "http://localhost:5000"
        : "https://rapidphysio-backend-ka9x.onrender.com";

function AdminLogin() {
    const [form, setForm] = useState({ username: '', password: '' });
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await fetch(`${API_BASE_URL}/api/admin/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(form)
            });

            const data = await res.json();

            if (res.ok && data.token) {
                localStorage.setItem('adminToken', data.token);
                navigate('/admin');
            } else {
                setError(data.message || 'Login failed');
            }
        } catch (err) {
            setError('Server error');
        }
    };

    return (
        <div style={styles.wrapper}>
            <div style={styles.container}>
                <div style={styles.avatarSection}>
                    <img
                        src="https://cdn-icons-png.flaticon.com/512/5087/5087579.png"
                        alt="Admin Avatar"
                        style={styles.avatar}
                    />
                    <h2 style={styles.title}>Admin Login</h2>
                </div>

                <form onSubmit={handleSubmit}>
                    <input
                        name="username"
                        placeholder="Username"
                        value={form.username}
                        onChange={handleChange}
                        required
                        style={styles.input}
                    />

                    <div style={styles.passwordWrapper}>
                        <input
                            name="password"
                            type={showPassword ? 'text' : 'password'}
                            placeholder="Password"
                            value={form.password}
                            onChange={handleChange}
                            required
                            style={{ ...styles.input, marginBottom: 0 }}
                        />
                        <button
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                            style={styles.toggleBtn}
                        >
                            {showPassword ? '🙈' : '👁️'}
                        </button>
                    </div>
                    <div style={{ marginBottom: 15 }} />

                    <button type="submit" style={styles.button}>Login</button>
                </form>

                {error && <p style={styles.error}>{error}</p>}
            </div>
        </div>
    );
}

const styles = {
    wrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundImage: 'url(https://c0.wallpaperflare.com/preview/198/135/731/cyber-attack-abstract-access.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '20px',
    },
    container: {
        width: '100%',
        maxWidth: '400px',
        padding: '30px',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderRadius: '10px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
    },
    avatarSection: {
        textAlign: 'center',
        marginBottom: '20px',
    },
    avatar: {
        width: '80px',
        height: '80px',
        borderRadius: '50%',
        marginBottom: '10px',
    },
    title: {
        margin: 0,
        color: '#333',
    },
    input: {
        width: '100%',
        padding: '12px',
        marginBottom: '15px',
        borderRadius: '6px',
        border: '1px solid #ccc',
        fontSize: '16px',
        boxSizing: 'border-box',
    },
    passwordWrapper: {
        position: 'relative',
        width: '100%',
    },
    toggleBtn: {
        position: 'absolute',
        right: '10px',
        top: '50%',
        transform: 'translateY(-50%)',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        fontSize: '18px',
    },
    button: {
        width: '100%',
        padding: '12px',
        backgroundColor: '#4CAF50',
        color: '#fff',
        border: 'none',
        borderRadius: '6px',
        fontSize: '16px',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
    },
    error: {
        color: 'red',
        marginTop: '10px',
        textAlign: 'center',
    }
};

export default AdminLogin;
